import { MatDialog } from "@angular/material/dialog";
import { RunnerDetailsDialogComponent } from "@app/shared/components/argument-card/runner-details-dialog/runner-details-dialog.component";

export enum Type {
  Azure, Github, Onpremise, Any
}

export enum System {
  Windows, Linux
}

export class RunnerData {
  type: Type;
  os: System;
  label: string;

  static readonly EXTRACT_PATTERN = /\[([^[\]]*)\]/g

  constructor(runnerData: string | RunnerData | void) {


    if (runnerData) {
      // extract data from
      // runner data object
      // or string like[value1][value2][value3] and assign to properties
      if (typeof runnerData === 'string') {
        for (let match of runnerData.matchAll(RunnerData.EXTRACT_PATTERN)) {
          let data: any = match[1];
          if (Type[data] != undefined) {
            this.type = data;
          } else if (System[data] != undefined) {
            this.os = data;
          } else {
            this.label = data;
          }
        }
      } else {
        this.type = runnerData.type;
        this.os = runnerData.os
        this.label = runnerData.label
      }
    }
  }

  toString() {
    return this.format(this.type) + this.format(this.os) + this.format(this.label);
  }

  format(value: Type | System | string) {
    return value ? "[" + value + "]" : "";
  }

  toJSON() {
    return {
      type: this.type,
      os: this.os,
      label: this.label
    }
  }
}

export function showRunnerDialog(dialog: MatDialog, data: any) {
  return dialog.open(RunnerDetailsDialogComponent, {
    data: data,
    autoFocus: false
  }).afterClosed();
}
